import { styled } from "@mui/material/styles";

export const StyledSimpleGridContainer = styled("div")(({ theme }) => ({
  overflow: "auto",
  position: "fixed",
  top: 250,
  right: 110,
  bottom: 68,
  left: 330,
  paddingBottom: 10
}));
